import Vue from 'vue'
import VCalendar from 'v-calendar'
// import { Calendar, DatePicker } from 'v-calendar'
// import Calendar from 'v-calendar/lib/components/calendar.umd'
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
// import GoogleAuth from 'vue-google-oauth'
// import 'v-calendar/lib/v-calendar.min.css'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css
import '@/styles/inter.scss' // global css
import '@/styles/poppins.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

import ProfilPemohonKad from '@/views/mypetrol/components/ProfilPemohonKad'
import SenaraiKenderaan from '@/views/mypetrol/components/SenaraiKenderaan'
import SyarikatMinyak from '@/views/mypetrol/components/SyarikatMinyak'
import AkuanSemakanPengesahan from '@/views/mypetrol/components/AkuanSemakanPengesahan'
import ProfilNew from '@/views/mypetrol/components/ProfilNew'
import VehicleNew from '@/views/mypetrol/components/VehicleNew'
import OilCompanyNew from '@/views/mypetrol/components/OilCompanyNew'
import VehicleFleetCard from '@/views/mypetrol/components/VehicleFleetCard'
import QuotaAdditionalNew from '@/views/mypetrol/components/QuotaAdditionalNew'

import ProfilPemohonKadDiesel from '@/views/mydiesel/components/ProfilPemohonKadDiesel'
import SenaraiKenderaanDiesel from '@/views/mydiesel/components/SenaraiKenderaanDiesel'
import SyarikatMinyakDiesel from '@/views/mydiesel/components/SyarikatMinyakDiesel'
import AkuanSemakanPengesahanDiesel from '@/views/mydiesel/components/AkuanSemakanPengesahanDiesel'
import ProfilNewDiesel from '@/views/mydiesel/components/ProfilNewDiesel'
import VehicleNewDiesel from '@/views/mydiesel/components/VehicleNewDiesel'
import OilCompanyNewDiesel from '@/views/mydiesel/components/OilCompanyNewDiesel'
import VehicleFleetCardDiesel from '@/views/mydiesel/components/VehicleFleetCardDiesel'
import QuotaAdditionalNewDiesel from '@/views/mydiesel/components/QuotaAdditionalNewDiesel'

Vue.component('ProfilPemohonKad', ProfilPemohonKad)
Vue.component('SenaraiKenderaan', SenaraiKenderaan)
Vue.component('SyarikatMinyak', SyarikatMinyak)
Vue.component('AkuanSemakanPengesahan', AkuanSemakanPengesahan)
Vue.component('ProfilNew', ProfilNew)
Vue.component('VehicleNew', VehicleNew)
Vue.component('OilCompanyNew', OilCompanyNew)
Vue.component('VehicleFleetCard', VehicleFleetCard)
Vue.component('QuotaAdditionalNew', QuotaAdditionalNew)

Vue.component('ProfilPemohonKadDiesel', ProfilPemohonKadDiesel)
Vue.component('SenaraiKenderaanDiesel', SenaraiKenderaanDiesel)
Vue.component('SyarikatMinyakDiesel', SyarikatMinyakDiesel)
Vue.component('AkuanSemakanPengesahanDiesel', AkuanSemakanPengesahanDiesel)
Vue.component('ProfilNewDiesel', ProfilNewDiesel)
Vue.component('VehicleNewDiesel', VehicleNewDiesel)
Vue.component('OilCompanyNewDiesel', OilCompanyNewDiesel)
Vue.component('VehicleFleetCardDiesel', VehicleFleetCardDiesel)
Vue.component('QuotaAdditionalNewDiesel', QuotaAdditionalNewDiesel)

Vue.use(ElementUI, { locale })
Vue.use(VCalendar)
// Vue.component('calendar', Calendar)
// Vue.component('date-picker', DatePicker)
// import Calendar from 'v-calendar/src/lib';

// Use v-calendar & v-date-picker components
// Vue.use(VCalendar, {
//   componentPrefix: 'vc',
// });
// Vue.component('calendar', Calendar)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js